module.exports = __webpack_public_path__ + "img/199.4efca559.gif";